import { render } from "./dealerInformation.vue?vue&type=template&id=27d7a528&scoped=true"
import script from "./dealerInformation.vue?vue&type=script&lang=js"
export * from "./dealerInformation.vue?vue&type=script&lang=js"

import "./dealerInformation.vue?vue&type=style&index=0&id=27d7a528&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27d7a528"]])

export default __exports__